import { Component, EventEmitter, inject, Input, OnInit, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { lastValueFrom } from "rxjs";
import { AuthService } from "src/app/shared/auth/services/auth.service";
import { ChamadoDeletar } from "src/app/shared/models/chamados/chamadoDeletar";
import { HistoricoChamado } from "src/app/shared/models/chamados/historico";
import { ListarChamados } from "src/app/shared/models/chamados/listar-chamados";
import { AtribuicaoLoginSed, UserLoginSed } from "src/app/shared/models/sed/UserLogin";
import { ChamadoService } from "src/app/shared/services/chamado.service";
import { ConcluirService } from "src/app/shared/services/concluir.service";
import { ConvivaErrorHandlingService } from "src/app/shared/services/convivaErrorHandlingService";
import { EncaminhamentoService } from "src/app/shared/services/encaminhamento.service";
import { angularCommonImports } from "src/app/shared/ui/angular-common";
import { convivaCommonImports } from "src/app/shared/ui/conviva-common";
import { libsCommonImports } from "src/app/shared/ui/libs-common";
import { ArquivoAzure } from 'src/app/shared/models/arquivo/ArquivoAzure';
import { EnvolvidoService } from "src/app/shared/services/envolvido.service";
import { ArquivoService } from 'src/app/shared/services/arquivo.service';
//Models
import { Envolvido } from "src/app/shared/models/chamados/envolvido";

@Component({
  selector: 'app-tres-pontos',
  templateUrl: './tres-pontos.component.html',
  styleUrls: ['./tres-pontos.component.scss'],
  standalone: true,
  imports:[angularCommonImports,convivaCommonImports,libsCommonImports]
}) 

export class TresPontosComponent implements OnInit {
  //Inject
  private authService = inject(AuthService);
  private router = inject(Router);
  private spinnerService = inject(NgxSpinnerService);
  private toastr = inject(ToastrService);
  private ConvivaErrors = inject(ConvivaErrorHandlingService);
  private chamadoService = inject(ChamadoService);
  private encaminhamento = inject(EncaminhamentoService);
  private concluirService = inject(ConcluirService)
  private envolvidoService = inject(EnvolvidoService);
  private arquivoService = inject(ArquivoService);

  public userLogado: UserLoginSed | null;
  public atribuicoesLogin: AtribuicaoLoginSed;

  constructor() {

    this.userLogado = this.authService.getUser();

    if (this.userLogado != null && !this.userLogado.flPsicologo) {
      this.atribuicoesLogin = this.userLogado?.DadosUsuario[0];
    }
  }

  @Input() public Index: number = 0;
  @Input() public Chamado: ListarChamados = new ListarChamados();
  @Input() public TemEnvolvido: boolean = false;

  @Output() ItemEvent = new EventEmitter<string>();

  public IsVisualizarChamado: boolean = false;

  // Modal Excluir
  public showModalExcluirChamado = false;
  public descricaoExclusao = "";
  public chamadoARemover = 0;

  // Modal Encerrar Chamado Envolvido
  public showModalConcluirChamado = false;
  public ShowModalEncerrarChamado = false;
  public descricaoConcluir = "";
  public codigoChamadoSelected = 0;
  public codigoEnvolvidoSelected = 0;
  public chamadoAConcluir = 0;
  public tipoEncaminhamento = "";
  public tipoEncaminhamentoPolicia = 0;
  public arquivos: string[] = [];
  public filesEncaminhamento: ArquivoAzure[] = [];
  public turmasEnvolvidos: Envolvido[] = [];
  public mensagemConfirmacaoEncaminhamento = "";
  public mensagemSucessoEncaminhamento = "";

  // Modal Encaminhamentos
  public showModal = false;
  public submittedModal = false;
  public tituloModal = "";
  public formModal!: FormGroup;
  public get modalForm() { return this.formModal.controls; }
  public cssBtnPsicologo = "";
  public cssBtnPolicia = "";
  public cssBtnHospital = "";
  public showModalConfirmarEncaminhamento = false;
  public showModalSelecionarEnvolvidoEncaminhamento = false;
  public showModalSucessoEncaminhamento = false;

  public async ngOnInit() {
    const url = this.router.url;
    if (url.includes("/detalhe/"))
      this.IsVisualizarChamado = true;
  }

  public VerificaStatusEnvolvido(): boolean {
    return (this.Chamado.aluno?.statusEnvolvido == 5 ||
      this.Chamado.aluno?.statusEnvolvido == 2 ||
      this.Chamado.aluno?.statusEnvolvido == 3 ||
      this.Chamado.aluno?.statusEnvolvido == 0);
  }

  public OnExcluirChamado(codigoChamdo: number) {
    this.showModalExcluirChamado = true;
    this.descricaoExclusao = `Deseja remover o chamado ?`;
    this.chamadoARemover = codigoChamdo;
  }

  public FecharModalExclusao() {
    this.showModalExcluirChamado = false;
    this.descricaoExclusao = "";
    this.chamadoARemover = 0;
  }

  public async ExcluirChamado(codigoChamado: number) {
    this.spinnerService.show();
    var chamadoDeletar: ChamadoDeletar = {
      cdChamado: codigoChamado,
      codigoPerfil: this.atribuicoesLogin.CodigoPerfil,
      nomePerfil: this.atribuicoesLogin.NomePerfil
    }
    var response = await lastValueFrom(this.chamadoService.setDeletarChamado(chamadoDeletar))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.spinnerService.hide();
    this.toastr.success('Chamado removido com sucesso!');
    this.FecharModalExclusao();
    this.ItemEvent.emit("Pesquisar");
  }

  public OnEditarChamado(codigoChamdo: number) {
    this.router.navigate([`/editar-chamados/${codigoChamdo}`]);
  }

  public OnVisualizarChamado(codigoChamdo: number) {
    this.router.navigate(['/detalhe/', codigoChamdo]);
  }

  public AbrirModalEncerrarChamado(codigoChamdo: number, codigoEnvolvido: number) {
    this.codigoChamadoSelected = codigoChamdo;
    this.codigoEnvolvidoSelected = codigoEnvolvido;
    this.ShowModalEncerrarChamado = true;
    this.descricaoConcluir = `Deseja encerrar o chamado deste Envolvido ?`;
    this.chamadoAConcluir = codigoChamdo;
  }

  public FecharModalEncerrarChamado() {
    this.ShowModalEncerrarChamado = false;
    this.codigoChamadoSelected = 0;
    this.codigoEnvolvidoSelected = 0;
    this.chamadoAConcluir = 0;
  }

  public async EncerrarChamado() {

    const objetoHistorico: HistoricoChamado = {
      codigoChamado: this.codigoChamadoSelected,
      codigoEnvolvido: this.codigoEnvolvidoSelected || this.Chamado.codigoEnvolvido,
      descricaoHistorico: 'Chamado deste envolvido foi encerrado.',
      statusChamado: 6,
      nomeArquivo: "",
      caminhoArquivo: "",
      conteudo: "",
      codigoPerfil: this.atribuicoesLogin.CodigoPerfil,
      nomePerfil: this.atribuicoesLogin.NomePerfil
    };

    this.FecharModalEncerrarChamado();

    this.spinnerService.show();

    const result = await lastValueFrom(await this.concluirService.setCadastrarConcluir(objetoHistorico))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });

    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      this.spinnerService.hide();
      return;
    }

    this.toastr.success('Chamado deste envolvido encerrado com sucesso.');
    this.spinnerService.hide();

    this.ItemEvent.emit("Pesquisar");
  }

  public async AbrirModalEncaminhamentos(codigoChamado: number, codigoEnvolvido: number) {
    this.codigoChamadoSelected = codigoChamado;
    this.codigoEnvolvidoSelected = codigoEnvolvido;
    this.submittedModal = false;
    this.formModal = new FormGroup({});
    this.showModal = true;
    this.tituloModal = 'Tipo de Encaminhamento';
    this.tipoEncaminhamento = ""
    this.mensagemConfirmacaoEncaminhamento = "";
    this.showModalSelecionarEnvolvidoEncaminhamento = false;

    this.cssBtnPsicologo = "";
    this.cssBtnPolicia = "";
    this.cssBtnHospital = "";

    const result = await lastValueFrom(await this.envolvidoService.GetEnvolvidosPorChamado(codigoChamado))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });

    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      this.spinnerService.hide();
      return;
    }
    this.turmasEnvolvidos = result.data;
    this.turmasEnvolvidos = this.turmasEnvolvidos.filter(item => item.dsEstatusEnvolvido === 'Não Analisado');

    if (this.turmasEnvolvidos.length == 0) {
      this.FecharModalEncaminhamentos();
      this.toastr.error("Chamado já encaminhado", "Atenção");
      this.spinnerService.hide();
      return;
    }

    if (this.turmasEnvolvidos.length == 1) {
      this.codigoEnvolvidoSelected = this.turmasEnvolvidos[0]?.codigoEnvolvido ?? 0;
      this.SelecionarVitima();
      return;
    }

    this.showModal = false;
    this.showModalSelecionarEnvolvidoEncaminhamento = true;

  }

  public FecharModalEncaminhamentos() {
    this.showModal = false;
  }

  public async EncaminhamentoPsicologo() {
    this.spinnerService.show();

    const objetoHistorico: HistoricoChamado = {
      codigoChamado: this.codigoChamadoSelected,
      codigoEnvolvido: this.codigoEnvolvidoSelected || this.Chamado.codigoEnvolvido,
      descricaoHistorico: 'Aluno encaminhado ao Psicólogo.',
      statusChamado: 2,//Encaminhado
      codigoPerfil: this.atribuicoesLogin.CodigoPerfil,
      nomePerfil: this.atribuicoesLogin.NomePerfil
    };

    var response = await lastValueFrom(this.encaminhamento.setCadastrarEncaminhamento(objetoHistorico))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    //this.ExibirMsgSucesso();
  }

  public async EncaminhamentoPolicia() {
    this.spinnerService.show();

    const objetoHistorico: HistoricoChamado = {
      codigoChamado: this.codigoChamadoSelected,
      codigoEnvolvido: this.codigoEnvolvidoSelected || this.Chamado.codigoEnvolvido,
      descricaoHistorico: 'Aluno encaminhado a Rede protetiva.',
      statusChamado: 2,//Encaminhado
      codigoPerfil: this.atribuicoesLogin.CodigoPerfil,
      nomePerfil: this.atribuicoesLogin.NomePerfil,
      anexos: this.filesEncaminhamento
    };

    var response = await lastValueFrom(this.encaminhamento.setCadastrarEncaminhamentoPolicia(objetoHistorico))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    //this.ExibirMsgSucesso();
  }

  public async EncaminhamentoSaude() {
    this.spinnerService.show();

    const objetoHistorico: HistoricoChamado = {
      codigoChamado: this.codigoChamadoSelected,
      codigoEnvolvido: this.codigoEnvolvidoSelected || this.Chamado.codigoEnvolvido,
      descricaoHistorico: 'Aluno encaminhado a Saúde.',
      statusChamado: 3,
      codigoPerfil: this.atribuicoesLogin.CodigoPerfil,
      nomePerfil: this.atribuicoesLogin.NomePerfil
    };

    var response = await lastValueFrom(this.encaminhamento.setCadastrarEncaminhamentoSaude(objetoHistorico))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    //this.ExibirMsgSucesso();

  }

  public podeConcluirChamado(chamado: ListarChamados) {
    return this.userLogado?.funcionalidades?.includes(2) &&
      this.Chamado.status != 4 ||
      this.Chamado.tpPessoa[0] == 3 &&
      (this.Chamado.semEnvolvido || this.Chamado.codigoCategoria == 6 || this.Chamado.status == 3);
  }

  public AbrirModalConcluirChamado(codigoChamdo: number) {
    this.showModalConcluirChamado = true;
    this.descricaoConcluir = `Deseja concluir o chamado ?`;
    this.chamadoAConcluir = codigoChamdo;
  }

  public FecharModalConcluir() {
    this.showModalConcluirChamado = false;
  }

  public async ConcluirChamado() {

    const objetoHistorico: HistoricoChamado = {
      codigoChamado: this.Chamado.codigoChamado,
      codigoEnvolvido: this.Chamado.codigoEnvolvido,
      descricaoHistorico: 'Chamado deste envolvido concluído.',
      statusChamado: 6,
      nomeArquivo: "",
      caminhoArquivo: "",
      conteudo: "",

    };

    this.FecharModalConcluir();
    this.spinnerService.show();

    var result = await lastValueFrom(await this.concluirService.setCadastrarConcluirChamadoEnvolvidos(objetoHistorico))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });

    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      this.spinnerService.hide();
      return;
    }

    this.spinnerService.hide();
    this.toastr.success('Chamado deste envolvido concluído com sucesso.');
    this.ItemEvent.emit("Pesquisar");
  }


  //  ***** Botoes de Encaminhamento *****
  public PrepararEncaminhamento(tipo: string){

    this.cssBtnPsicologo = "";
    this.cssBtnPolicia = "";
    this.cssBtnHospital = "";
        
    switch (tipo) {
      case "psicologo": //psicologo
        this.cssBtnPsicologo = "btn-encaminhamento-checado";
        this.tipoEncaminhamento = "psicologo";
        break;  
      case "rede-protetiva"://policia
        this.cssBtnPolicia = "btn-encaminhamento-checado";
        this.tipoEncaminhamento = "rede-protetiva";
        break;
      case "rede-hospitalar"://hospitalar
        this.cssBtnHospital = "btn-encaminhamento-checado";
        this.tipoEncaminhamento = "rede-hospitalar";
        break;
    }  
  
  }

  public CancelarEncaminhamento(){

    const divMsg = document.getElementById("dvMensagemConfirmar");
    const divEncaminhar = document.getElementById("dvEncaminhar");

     if (divEncaminhar && divMsg) {

        divMsg.style.display = 'none';
        divEncaminhar.style.display = 'block';
     }
  }

  public async SalvarEncaminhamento(){
        switch (this.tipoEncaminhamento) {
          case "psicologo":
            this.EncaminhamentoPsicologo();
            break;    
          case "rede-protetiva":
            await this.EncaminhamentoPolicia();
            break;
          case "rede-hospitalar":
            await this.EncaminhamentoSaude();
            break;
        }
  }

  public MensagemConfirmarEncaminhamento(){

    this.spinnerService.hide();
    this.toastr.success(this.mensagemConfirmacaoEncaminhamento);
    this.FecharModalEncaminhamentos();
    this.OnVisualizarChamado(this.codigoChamadoSelected);

  }

  public solicitarConfirmacaoEncaminhamento(){
    this.spinnerService.hide();

    switch (this.tipoEncaminhamento) {
          case "psicologo":
            this.mensagemConfirmacaoEncaminhamento ="Aluno Encaminhado ao Psicologo com Sucesso.";
            break;    
          case "rede-protetiva":
            if (this.tipoEncaminhamentoPolicia == 0) {
              return;
            }
            this.mensagemConfirmacaoEncaminhamento ="Aluno Encaminhado a Rede Protetiva com Sucesso.";
            break;
          case "rede-hospitalar":
            this.mensagemConfirmacaoEncaminhamento ="Aluno Encaminhado a Rede Hospitalar com Sucesso.";
            break;
        }

    this.showModal = false;
    this.showModalConfirmarEncaminhamento = true;
  }

  public async confirmarEncaminhamento() {
    this.showModalConfirmarEncaminhamento = false;

    if (!this.tipoEncaminhamento) {
      this.toastr.warning('Selecione um tipo de encaminhamento');
      return;
    }

    this.spinnerService.show();

    let objetoHistorico: HistoricoChamado;
    let response: any;

    switch (this.tipoEncaminhamento) {
      case 'psicologo':
        objetoHistorico = {
          codigoChamado: this.codigoChamadoSelected,
          codigoEnvolvido: this.codigoEnvolvidoSelected,
          descricaoHistorico: 'Aluno encaminhado ao Psicólogo.',
          statusChamado: 2,
          codigoPerfil: this.userLogado?.flPsicologo ? this.userLogado.codigoPerfil : this.atribuicoesLogin.CodigoPerfil,
          nomePerfil: this.userLogado?.flPsicologo ? this.userLogado.nomePerfil : this.atribuicoesLogin.NomePerfil,
          nomeArquivo: "",
          caminhoArquivo: "",
          conteudo: ""
        };
        response = await lastValueFrom(this.encaminhamento.setCadastrarEncaminhamento(objetoHistorico))
          .catch((err) => {
            return this.ConvivaErrors.handleResultError(err);
          });
        break;

      case 'rede-protetiva':
        objetoHistorico = {
          codigoChamado: this.codigoChamadoSelected,
          codigoEnvolvido: this.codigoEnvolvidoSelected,
          descricaoHistorico: 'Aluno encaminhado a Rede protetiva.',
          statusChamado: 2,
          codigoPerfil: this.userLogado?.flPsicologo ? this.userLogado.codigoPerfil : this.atribuicoesLogin.CodigoPerfil,
          nomePerfil: this.userLogado?.flPsicologo ? this.userLogado.nomePerfil : this.atribuicoesLogin.NomePerfil,
          nomeArquivo: this.filesEncaminhamento.length > 0 ? this.filesEncaminhamento[0].nome : "",
          caminhoArquivo: this.filesEncaminhamento.length > 0 ? this.filesEncaminhamento[0].caminhoAzure : "",
          conteudo: this.filesEncaminhamento.length > 0 ? this.filesEncaminhamento[0].conteudo : "",
          anexos: this.filesEncaminhamento        
        };
        response = await lastValueFrom(this.encaminhamento.setCadastrarEncaminhamentoPolicia(objetoHistorico))
          .catch((err) => {
            return this.ConvivaErrors.handleResultError(err);
          });
        break;

      case 'rede-hospitalar':
        objetoHistorico = {
          codigoChamado: this.codigoChamadoSelected,
          codigoEnvolvido: this.codigoEnvolvidoSelected,
          descricaoHistorico: 'Aluno encaminhado a Rede Hospitalar.',
          statusChamado: 3,
          codigoPerfil: this.userLogado?.flPsicologo ? this.userLogado.codigoPerfil : this.atribuicoesLogin.CodigoPerfil,
          nomePerfil: this.userLogado?.flPsicologo ? this.userLogado.nomePerfil : this.atribuicoesLogin.NomePerfil,
          nomeArquivo: "",
          caminhoArquivo: "",
          conteudo: ""
        };
        response = await lastValueFrom(this.encaminhamento.setCadastrarEncaminhamentoSaude(objetoHistorico))
          .catch((err) => {
            return this.ConvivaErrors.handleResultError(err);
          });
        break;

      default:
        this.spinnerService.hide();
        return;
    }

    if (!response.isSucess) {
      this.toastr.error(response.message, response.title);
      this.spinnerService.hide();
      return;
    }

    this.spinnerService.hide();
    
    const mensagens: { [key: string]: string } = {
      'psicologo': 'Encaminhamento ao Psicólogo realizado com sucesso.',
      'rede-protetiva': 'Encaminhamento à Rede Protetiva realizado com sucesso.',
      'rede-hospitalar': 'Encaminhamento à Rede Hospitalar realizado com sucesso.'
    };
    
    this.mensagemSucessoEncaminhamento = mensagens[this.tipoEncaminhamento];
    
    // Fecha modal de confirmação e abre modal de sucesso
    this.showModalConfirmarEncaminhamento = false;
    this.showModalSucessoEncaminhamento = true;
  }

  public fecharModalConfirmacaoEncaminhamento() {
    this.showModalConfirmarEncaminhamento = false;
    // Volta para o modal de seleção
    this.showModal = true;
  }

   public fecharModalSucessoEncaminhamento() {
    this.showModalSucessoEncaminhamento = false;
    // Redireciona para a tela de chamados
    setTimeout(() => {
      this.OnVisualizarChamado(this.codigoChamadoSelected);
    }, 500);
  }

  // ***** Anexos *****
  public removerArquivoEncaminhamento(index: number) {
    this.arquivos.splice(index, 1);
    this.filesEncaminhamento.splice(index, 1);
  }

  public adicionarArquivo() {
    const arquivoInput = document.getElementById('fl-arquivos') as HTMLInputElement;
    arquivoInput?.click();
  }

  public async onFileChangeEncaminhamento(event: any) {
    const maxFileSize = 31 * 1024 * 1024; // 30 MB

    if (event.target.files.length > 0) {
      this.spinnerService.show();
      const formData = new FormData();
      const filesUp = event.target.files;
      for (const file of filesUp) {
        const fileName = file.name.split('.')[0];

        if (fileName.length > 30) {
          const fileInput = document.getElementById('arquivos') as HTMLInputElement;
          if (fileInput) {
            fileInput.value = '';
          }
          this.toastr.warning('O nome do arquivo não pode ter mais de 30 caracteres.');
          this.spinnerService.hide();
          return;
        }

        if (file.size > maxFileSize) {
          this.toastr.warning('O tamanho máximo do arquivo é 30 MB.');
          const fileInput = document.getElementById('arquivos') as HTMLInputElement;
          if (fileInput) {
            fileInput.value = '';
          }
          this.spinnerService.hide();
          return;
        }

        if (file.type == "image/jpg" ||
          file.type == "image/jpeg" ||
          file.type == "image/png" ||
          file.type == "application/pdf" ||
          file.type == "application/ppt" ||
          file.type == "application/pptx" ||
          file.type == "application/potx" ||
          file.type == "application/ppsx" ||
          file.type == "application/odp" ||
          file.type == "audio/mpeg" ||
          file.type == "video/mp4"
        ) {
          formData.append(file.name, file);
          this.arquivos.push(file.name);
        }
        else {
          this.toastr.warning('Só é possivel subir arquivos .jpg, .jpeg , .png, .pdf, .mp3 , .mp4, .ppt, .pptx, .potx e ppsx');
          const fileInput = document.getElementById('arquivos') as HTMLInputElement;
          if (fileInput) {
            fileInput.value = '';
          }
          this.spinnerService.hide();
          return;
        }
      }


      const result = await lastValueFrom(this.arquivoService.setArquivoBase64(formData))
        .catch((err) => {
          return this.ConvivaErrors.handleResultError(err);
        });

      if (!result.isSucess) {
        this.toastr.error(result.message, result.title);
        this.spinnerService.hide();
        return;
      }

      this.filesEncaminhamento.push(...result.data);
      event.target.value = '';

      this.spinnerService.hide();
    }
  }


  // ***** Envolvidos *****
  public SelecionarVitima(){
    if (this.codigoEnvolvidoSelected > 0) {
        this.showModal = true;
        this.showModalSelecionarEnvolvidoEncaminhamento = false;
      }
  }

  public onChangeEnvolvido(event: any){
      this.codigoEnvolvidoSelected = event.target.value;
  }
  

  // ***** Tipo de encaminhamento para rede protetiva *****
  public onChangeTEP(tipo: number){

    const divAlerta = document.getElementById("dvAlerta");
    const elements: NodeListOf<HTMLElement> = document.getElementsByName('encaminhamento');

     if (elements && divAlerta) {

        elements.forEach(el => el.classList.remove('msg-alerta'));
        divAlerta.style.display = 'none';
        this.tipoEncaminhamentoPolicia = tipo;
     }

  }

  extraiNomeArquivoDaUrlComGuid(caminho: string) {
    const segmento = caminho.split('/').pop() ?? '';
    const semQuery = segmento.includes('?') ? segmento.split('?')[0] : segmento;
    try {
      return decodeURIComponent(semQuery);
    } catch {
      return semQuery;
    }
  }
  extraiNomeArquivoDaURLSemGuid(url: string | undefined) {
    if (!url)
      return '';
    const nomeArquivo = this.extraiNomeArquivoDaUrlComGuid(url);
    const regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}-/;
    const nomeAquivoLimpo = nomeArquivo.replace(regex, '');
    try {
      return decodeURIComponent(nomeAquivoLimpo);
    } catch (error) {
      // Se fallar a decodificação, retorna o nome sem decodificar
      return nomeAquivoLimpo;
    }
  }

}
